import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import { Helmet } from 'react-helmet'

const cardD = [
  {
    img: false,
    title: "Assessment",
    para:'A licensed audiologist performs a detailed hearing test and evaluates your auditory health.',
    number:"01",
    id: 1,
  },
  {
    img: false,
    title: "Consultation",
    para:'Test results are reviewed and discussed, including options for management, prevention, or treatment.',
    number:"02",
    id: 2,
  },
  {
    img: false,
    title: "Follow-up Plan",
    para:'If needed, our team will recommend hearing aids, protective devices, or referrals to ENT specialists.',
    number:"03",
    id: 3,
  },
]

const cardList = [
  {
     link:"/aging-wellness-clinic",
        img:"/images/creatives/service-main-7.webp",
    name:"Aging and Wellness Clinic",
    rank:"",
    para:'Comprehensive geriatric assessments to support the aging population.'
  },
  {
     link:"/global-medical-consulting",
        img:"/images/creatives/service-main-4.webp",
    name:" Global Medical Consulting",
    rank:"",
    para:'Access top international experts for rare or complex conditions.'
  },
]

const boostCardData = [
    "Detect hearing loss early and accurately",
    "Get personalized recommendations from licensed professionals",
    "Prevent further hearing damage with proactive care",
    "Improve communication and daily quality of life",
]

function Audiology() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Audiology Services Toronto | Hearing Tests & Tinnitus Assessment
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/audiology"
        />
        <meta
          name="description"
          content="Professional audiology services in Toronto including hearing tests, tinnitus assessments, and personalized hearing solutions. Protect and enhance your hearing with expert care."
        ></meta>
      
      </Helmet>
         <Header/>
        <HomeHero
            heading='Audiology'
            content='Advanced hearing diagnostics and personalized care to protect and enhance auditory health.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/audiologyhero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
            calendlyType={7}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="Our audiology services offer comprehensive hearing evaluations, tinnitus assessments, and support for hearing loss at any age. Using state-of-the-art diagnostic tools, we help you understand your hearing profile and guide you toward solutions that fit your lifestyle."
            bgImg="/images/creatives/service-main-2.webp"
          />

          <div className='pt-4'></div>
          {/* <SlideScrollContent
            cardData={cardD}
            noContent={true}
          /> */}
          <BoostshootRowCard
            cards={cardD}
          />
          <div className='pb-5'></div>
        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />

        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph="Audiology pairs well with services that support aging well and full-spectrum preventative care."
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default Audiology